export const dynamicPickerPaperProps = Object.freeze({
  sx: Object.freeze({
    width: 'fit-content',
    minWidth: 360,
    maxWidth: '90vw',
    maxHeight: 560,
    p: 2,
    overflowY: 'auto',
  }),
});

export const dynamicEmptyPickerPaperProps = Object.freeze({
  sx: Object.freeze({ p: 2, maxWidth: 320 }),
});

export const getSignatureAnchorSx = anchorRect => ({
  position: 'fixed',
  left: anchorRect.x,
  top: anchorRect.y,
  width: Math.max(anchorRect.width, 1),
  height: Math.max(anchorRect.height, 1),
  pointerEvents: 'none',
  '& > span > :first-child': {
    visibility: 'hidden',
  },
});
